module.exports = "/_next/static/images/creatinine-0a723666bb18c2829a66d224e7d1087e.png";